import type { StickId } from "./variant-images";

// The color picker no longer has a hardcoded swatch list here (2026-08-23) -- colors are now
// admin-managed data (dbo.Colors, see /admin/products/colors), fetched live from GET /api/colors,
// not a fixed set anyone editing this file would need to keep in sync.

/**
 * "Which stick do you have?" is framed around pole length, but Products.Fitment (the actual
 * purchasable attribute) is the mount's collar diameter -- two different pole lengths can share the
 * same fitment. This is the one place that mapping lives, so it's a single edit if the catalog ever
 * splits 85cm/114cm into distinct fitment SKUs.
 */
export const STICKS: { id: StickId; label: string; fitment: string }[] = [
  { id: "85", label: "85cm · 23mm", fitment: "23mm" },
  { id: "100", label: "100cm · 25mm", fitment: "25mm" },
  { id: "114", label: "114cm · 23mm", fitment: "23mm" },
];
